import { render, staticRenderFns } from "./ChooseAddon.vue?vue&type=template&id=ff8dfbd4&scoped=true&"
import script from "./ChooseAddon.vue?vue&type=script&lang=js&"
export * from "./ChooseAddon.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAddon.vue?vue&type=style&index=0&id=ff8dfbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8dfbd4",
  null
  
)

export default component.exports